import * as React from 'react';
import Checkbox from './Checkbox';
import { styled } from 'linaria/react';
export const Radio = /*#__PURE__*/styled(Checkbox)({
  name: "Radio",
  class: "rb9a7a4"
});
const Label = /*#__PURE__*/styled('span')({
  name: "Label",
  class: "l1exij6x"
});
export const CheckboxWrapper = /*#__PURE__*/styled('div')({
  name: "CheckboxWrapper",
  class: "c1f2rxz1"
});

const CheckboxGroup = ({
  selectedItem,
  items,
  handleChange,
  groupLabel,
  className
}) => React.createElement(CheckboxWrapper, {
  className: className
}, groupLabel && React.createElement(Label, null, groupLabel), items.map(item => React.createElement(Radio, {
  type: "radio",
  key: item.val,
  value: item.val,
  tabIndex: 0,
  checked: selectedItem === item.val ? true : false,
  label: item.label,
  onChange: () => handleChange(item.val)
})));

export default CheckboxGroup;

require("../../../../.linaria-cache/node_modules/@jetshop/ui/Checkbox/CheckboxGroup.linaria.css");